var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curation_request"},[_c('div',{staticClass:"ifmf_title"},[_vm._v(_vm._s(_vm.$t('c_request')))]),_c('curation-write-component',{attrs:{"curationType":'curationWrite'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }